import { Suspense } from "react";
import Header from "./components/header/header";
import { Route, Routes } from "react-router-dom";
import "./App.scss";
import ProgressIndicator from "./components/progress-indicator";

function App() {
  return (
    <Suspense fallback={<ProgressIndicator />}>
      <Routes>
        <Route path={"/join-us"} element={<Header />} />
      </Routes>
    </Suspense>
  );
}

export default App;
